(function () {
    'use strict';

    var serviceId = 'endeksaGeocode';

    angular.module('app.common')
        .factory(serviceId, ['$q', '$http', '$timeout', 'appSettingsSvc', 'CacheFactory', endeksaGeocode]);

    function endeksaGeocode($q, $http, $timeout, appSettingsSvc, CacheFactory) {

        var storageImpl = {
            getItem: function (key) { return localStorage.getItem(key); },
            setItem: function (key, value) {
                try {
                    return localStorage.setItem(key, value);
                } catch (err) {
                    const accessToken = localStorage.getItem('accessToken');
                    const accessTokenExpires = localStorage.getItem('accessTokenExpires');
                    const refreshToken = localStorage.getItem('refreshToken');
                    const refreshTokenExpires = localStorage.getItem('refreshTokenExpires');
                    localStorage.clear();
                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('accessTokenExpires', accessTokenExpires);
                    localStorage.setItem('refreshToken', refreshToken);
                    localStorage.setItem('refreshTokenExpires', refreshTokenExpires);
                    window.userStorage.sync();
                    return localStorage.setItem(key, value);
                }
            },
            removeItem: function (key) { return localStorage.removeItem(key); },
        };
        if (!CacheFactory.get('GeoMap'))
            CacheFactory('GeoMap', {
                deleteOnExpire: 'aggressive',
                maxAge: 24 * 60 * 60 * 1000,
                storageImpl: storageImpl,
                //  storageMode: 'localStorage'
            });

        if (!CacheFactory.get('GeoMapAddress'))
            CacheFactory('GeoMapAddress', {
                deleteOnExpire: 'aggressive',
                maxAge: 24 * 60 * 60 * 1000,
                storageImpl: storageImpl,
                //  storageMode: 'localStorage'
            });

        var obj = {
            geocodeAddress: geocodeAddress,
            geocodeUrl: geocodeUrl
        };

        return obj;

        function geocodeAddress(address) {
            var deferred = $q.defer();
            var cache = CacheFactory.get('GeoMapAddress');
            $http({
                dataType: 'json',
                data: '',
                method: 'GET',
                cache: cache,
                timeout: deferred.promise,
                skipAuthorization: true,
                url: appSettingsSvc.CACHE + '/geo/coding?searchText=' + encodeURI(address) + '&language=' + window.langCode()
            }).then(
                function (geocodeOk) {
                    if (geocodeOk.data && geocodeOk.data.length) {
                        geocodeOk.data =  JSON.parse(window.encodeResponse(geocodeOk.data));
                        deferred.resolve({
                            lat: function () {
                                var lat = geocodeOk.data[0].Lat;
                                return lat;
                            },
                            lng: function () {
                                var lng = geocodeOk.data[0].Lon;
                                return lng;
                            },
                            cityId: geocodeOk.data[0].CityId,
                            city: geocodeOk.data[0].CityName,
                            countyId: geocodeOk.data[0].CountyId,
                            county: geocodeOk.data[0].CountyName,
                            districtId: geocodeOk.data[0].DistrictId,
                            district: geocodeOk.data[0].DistrictName
                        });
                    }
                    else {
                        deferred.reject({
                            lat: function () { return null; },
                            lng: function () { return null; },
                            data: 'Konum Bulunamadi',
                            errorType: 2
                        });
                    }

                }, function () {
                    deferred.reject({
                        lat: function () { return null; },
                        lng: function () { return null; },
                        data: 'Konum Bulunamadi',
                        errorType: 2
                    });
                });

            return deferred.promise;
        }

        function doGeocode(country, city, county, district, block, parcel, deferred, quarter) {
            var cache = CacheFactory.get('GeoMap');

            if (block && block.indexOf('/') > -1 && !parcel) {
                parcel = block.split('/')[1];
                block = block.split('/')[0];
            }

            $http({
                dataType: 'json',
                method: 'GET',
                cache: cache,
                timeout: deferred.promise,
                skipAuthorization: true,
                url: appSettingsSvc.CACHE + '/geo/coding?countryname=' + normalizeAddress(country) + '&cityname=' + (city ? normalizeAddress(city) : '') + '&countyname=' + (county ? normalizeAddress(county) : '') + (quarter ? '&quartername=' + normalizeAddress(quarter) : '') + '&districtname=' + (district ? normalizeAddress(district) : '') + '&block=' + (block ? block : '') + '&parcel=' + (parcel ? parcel : '')
            }).then(
                function (geocodeOk) {
                    if (geocodeOk && geocodeOk.data) {
                        geocodeOk.data =  JSON.parse(window.encodeResponse(geocodeOk.data));
                        var result = {
                            lat: function () {
                                var lat = geocodeOk.data.Lat;
                                return lat;
                            },
                            lng: function () {
                                var lng = geocodeOk.data.Lon;
                                return lng;
                            },
                            countryId: geocodeOk.data.CountryId,
                            country: geocodeOk.data.CountryName,
                            cityId: geocodeOk.data.CityId,
                            city: geocodeOk.data.CityName,
                            county: geocodeOk.data.CountyName,
                            countyId: geocodeOk.data.CountyId,
                            district: geocodeOk.data.DistrictName,
                            districtId: geocodeOk.data.DistrictId,
                            parcelId: geocodeOk.data.ParcelId,
                            blockId: geocodeOk.data.BlockId,
                            population: geocodeOk.data.Population
                        }
                        deferred.resolve(result);
                    }
                    else {
                        deferred.reject({
                            lat: function () { return null; },
                            lng: function () { return null; },
                            data: 'Konum Bulunamadi',
                            errorType: 2
                        });
                    }

                }, function (error) {
                    deferred.reject({
                        lat: function () { return null; },
                        lng: function () { return null; },
                        data: 'Konum Bulunamadi',
                        errorType: 2
                    });
                    // $timeout(function () { doGeocode(country, city, county, district, block, parcel, deferred); }, 2000);
                });
        }

        function geocodeUrl(country, city, county, district, block, parcel, quarter) {
            var deferred = $q.defer();
            if (city && city.toLocaleLowerCase2('tr-tr').indexOf("reg-") > -1 || city && city.toLocaleLowerCase2('tr-tr').indexOf("reg-") > -1) {
                deferred.resolve({
                    lat: function () {
                        var lat = 40.9833;
                        return lat;
                    },
                    lng: function () {
                        var lng = 29.1167;
                        return lng;
                    },
                    country: 'Türkiye'
                });
            }
            else
                doGeocode(country, city, county, district, block, parcel, deferred, quarter);

            return deferred.promise;
        }
    }
})();
